/* Native Shopify variants own price and availability. Properties carry free personalisation only. */
(() => {
  const messages = JSON.parse(document.getElementById('GJNativeMessages')?.textContent || '{}');
  const path = (suffix) => `${window.Shopify?.routes?.root || '/'}${suffix}`;
  const json = async (response) => {
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || data.message || messages.cartError);
    return data;
  };
  const getCart = () => fetch(path('cart.js'), { headers: { Accept: 'application/json' } }).then(json);
  const isLegacy = (item) => Object.keys(item.properties || {}).some((key) => /^_ymq|^_parent_key$|^_linked_to$/.test(key));
  const syncPrice = (owner) => {
    const source = owner.querySelector('[data-gj-native-price]');
    const total = owner.querySelector('[data-gj-total-value]');
    if (!source || !total) return;
    const box = owner.querySelector('[data-gj-express]');
    total.closest('.gj-native-total').hidden = !box?.checked;
    const cents = Number(source.dataset.price) + (box?.checked ? Number(box.dataset.price) : 0);
    const value = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', { style: 'currency', currencyDisplay: 'narrowSymbol', currency: source.dataset.currency || 'AUD' }).format(cents / 100) + ' ' + (source.dataset.currency || 'AUD');
    if (total.textContent !== value) total.textContent = value;
  };
  const initialise = (owner) => {
    const state = { editKey: new URLSearchParams(location.search).get('gj_edit'), item: null, failure: null };
    if (state.editKey) {
      const fastCheckout = owner.querySelector('.shopify-payment-button');
      if (fastCheckout) fastCheckout.hidden = true;
    }
    const root = owner.closest('product-info');
    owner.addEventListener('change', () => syncPrice(owner));
    root?.addEventListener('gj:variant-updated', () => syncPrice(owner));
    syncPrice(owner);
    state.ready = (async () => {
      if (!state.editKey || !owner.dataset.productId) return;
      try {
        const cart = await getCart();
        const item = cart.items.find((line) => line.key === state.editKey && String(line.product_id) === owner.dataset.productId);
        if (!item) throw new Error(messages.editError);
        if (isLegacy(item)) throw new Error(messages.legacyEdit);
        state.item = item;
        const fields = [...owner.form.elements];
        for (const [key, value] of Object.entries(item.properties || {})) {
          const name = `properties[${key}]`;
          let field = fields.find((input) => input.name === name);
          if (!field) {
            field = document.createElement('input');
            field.type = 'hidden'; field.name = name; owner.form.append(field);
          }
          if (field.tagName === 'SELECT' && ![...field.options].some((option) => option.value === String(value))) {
            field.add(new Option(String(value), String(value)));
          }
          field.value = value;
        }
        const quantity = fields.find((input) => input.name === 'quantity');
        if (quantity) quantity.value = item.quantity;
      } catch (error) { state.failure = error; owner.handleErrorMessage(error.message); }
    })();
    return state;
  };
  const prepare = async (owner, formData) => {
    const state = owner.nativeState;
    if (state?.failure) throw state.failure;
    if (owner.dataset.nativeBlocked === 'true') throw new Error(messages.variantError);
    for (const [key, value] of [...formData]) {
      if (key.startsWith('properties[') && typeof value === 'string' && !value.trim()) formData.delete(key);
    }
    formData.set('properties[_gj_native_options]', '1');
    const box = owner.querySelector('[data-gj-express]');
    let cart, edit;
    if (state?.editKey || box?.checked) cart = await getCart();
    if (state?.editKey) {
      edit = cart.items.find((line) => line.key === state.editKey && String(line.product_id) === owner.dataset.productId);
      if (!edit || isLegacy(edit)) throw new Error(messages.editError);
      if (!formData.has('quantity')) formData.set('quantity', edit.quantity);
    }
    if (box?.checked && !cart.items.some((item) => String(item.variant_id) === box.dataset.variantId)) {
      const entries = [...formData];
      for (const [key, value] of entries) {
        if (key === 'id' || key === 'quantity' || key === 'selling_plan' || key.startsWith('properties[')) {
          formData.delete(key);
          const field = key.startsWith('properties[') ? `items[0][properties][${key.slice(11, -1)}]` : `items[0][${key}]`;
          formData.append(field, value);
        }
      }
      if (!formData.has('items[0][quantity]')) formData.set('items[0][quantity]', '1');
      formData.append('items[1][id]', box.dataset.variantId);
      formData.append('items[1][quantity]', '1');
    }
    return { cart, edit, quantity: Number(formData.get('quantity') || formData.get('items[0][quantity]') || 1) };
  };
  const finishEdit = async (owner, response, context) => {
    if (!context.edit) return response;
    const added = response.items?.find((item) => String(item.product_id) === owner.dataset.productId) || response;
    if (!added.key) throw new Error(messages.editPartial);
    const sections = owner.cart?.getSectionsToRender().map((section) => section.id) || [];
    try {
      const cart = await fetch(path('cart/change.js'), {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: context.edit.key, quantity: added.key === context.edit.key ? context.quantity : 0, sections, sections_url: location.pathname }),
      }).then(json);
      owner.nativeState.editKey = null;
      const url = new URL(location.href); url.searchParams.delete('gj_edit'); history.replaceState({}, '', url);
      return { ...response, sections: cart.sections || response.sections };
    } catch (error) {
      // Do not retry the successful add; both lines remain reviewable in the cart.
      owner.nativeState.editKey = null;
      throw new Error(messages.editPartial);
    }
  };
  window.GJNative = { messages, initialise, prepare, finishEdit, syncPrice };
})();
